import * as stylex from "@stylexjs/stylex";

import {
  SignInCardContent,
  SignInCardError,
  SignInCardFooter,
  SignInCardHeader,
  SignInCardLoading,
  SignInCardSuccess,
} from "./components.tsx";
import { card } from "./styles.stylex";

interface SignInCardProps {
  children: React.ReactNode;
  style?: stylex.StyleXStyles;
}

function SignInCardRoot({ children, style }: SignInCardProps) {
  return (
    <div {...stylex.props(card.container, style)}>
      <div {...stylex.props(card.card)}>{children}</div>
    </div>
  );
}

const SignInCard = Object.assign(SignInCardRoot, {
  Header: SignInCardHeader,
  Error: SignInCardError,
  Content: SignInCardContent,
  Footer: SignInCardFooter,
  Loading: SignInCardLoading,
  Success: SignInCardSuccess,
});

export { SignInCard, type SignInCardProps };
